import { Component, OnInit, ChangeDetectorRef, ElementRef, ViewChild, Input } from '@angular/core';
import { HttpService, QueovalDateService, CoreService } from '../services';
import { ConditionModel, ConditionDocumentsModel, NewConditionModel, SubModel2, ConditionColumnsModel, ConditionContext } from '../models/facturation/conditions.model';
import { ToastService } from '../toast';

@Component({
  selector: 'q-conditions',
  templateUrl: './conditions.component.html',
  styleUrls: ['./conditions.component.css']
})

export class ConditionsComponent implements OnInit {
  public andOr: string[] = ['and', 'or'];

  public contextModel: Array<ConditionContext> = new Array<ConditionContext>();

  public allnameModels: ConditionColumnsModel[];
  public nameModel: Map<string, string> = new Map<string, string>();
  public operatorModel: string[] = ['egal', 'not-egal', 'exist', 'not-exist', 'smaller', 'greater'];

  public conditionModel: NewConditionModel = new NewConditionModel();
  public newconditionModel: SubModel2 = new SubModel2();
  public listDocuments: Array<ConditionDocumentsModel> = new Array<ConditionDocumentsModel>();

  public listIdToDelete: Array<number> = new Array<number>();
  public edit: boolean = false;
  public selectedCodeCondition: string = '0';

  public keyValuePairAdded: { key: number, value: string }[] = [];

  public nomExistant: boolean = false;

  public modeleLoading: boolean = false;
  public saveLoading: boolean = false;
  public deleteLoading: boolean = false;

  @ViewChild('hideModalDelete', { static: false }) closeDelete: ElementRef;

  @Input('code') set SetCode(value: string) {
    if (value) {
      this.selectedCodeCondition = value.toUpperCase();
    } else {
      this.selectedCodeCondition = '0';
    }
    if (this.listDocuments && this.listDocuments.length > 0) {
      this.LoadFile(this.selectedCodeCondition);
    }
  }

  constructor(
    protected http: HttpService,
    public core: CoreService,
    private indParam: CoreService,
    protected toastservice: ToastService,
    public qDateService: QueovalDateService,
    public cd: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.core.showSplash(false);

    this.modeleLoading = true;
    this.http.getHttp<ConditionModel>(`${this.core.AppParams.apiUrl}api/spefCompta/Conditions/GET_DOCS_LIST/0`).subscribe(
      (result: ConditionModel) => {
        this.listDocuments = result.lstDocuments;

        this.LoadFile(this.selectedCodeCondition);

        // calling the function with no arguments:
        this.modeleLoading = false;
      })
    this.http.getHttp<ConditionModel>(`${this.core.AppParams.apiUrl}api/spefCompta/Conditions/GET_COLUMNS/0`).subscribe(
      (result: ConditionModel) => {
        this.allnameModels = result.ColumnsOfTables;
        this.contextModel = result.contexts;
      })

  }

  public NameAlreadyExist(modelName: string) {
    const selectedModelWithoutExtension: string = this.selectedCodeCondition.toLowerCase().replace(/.xml$/, '');
    const modelNameWithoutExtension: string = modelName.toLowerCase().replace(/.xml$/, '');

    if (selectedModelWithoutExtension !== modelNameWithoutExtension) {
      const exist: ConditionDocumentsModel | undefined = this.listDocuments.find((el: ConditionDocumentsModel) => {
        return el.ident === modelName || el.name === modelName
      })
      if (exist) { this.nomExistant = true; } else { this.nomExistant = false; }
    } else {
      this.nomExistant = false;
    }
  }

  public AddLine(): void {
    if (this.SelectCheck(this.newconditionModel)) {
      this.toastservice.showWarningToast(`Assurez-vous que les champs soient bien renseignées`);
    } else {
      this.newconditionModel.ident = new Date().getTime();
      this.conditionModel.lstConditions.push(this.newconditionModel);
      setTimeout(() => {
        const value: string = ($(`#newContext option:selected`)[0].attributes as any)['value'].value;
        this.keyValuePairAdded.push({ key: this.newconditionModel.ident, value: value })

        $(`#contextEdit${this.conditionModel.lstConditions.length - 1}`).html(value);
        $(`#ligneContext option`).filter(function (): any { return (($(this).attr('value') as string).toUpperCase() as any).indexOf(value.toUpperCase()) > -1 }).prop('selected', true);
        this.newconditionModel = new SubModel2();
        $(`#newContext option:selected`).removeProp("selected");
        this.cd.detectChanges();
      }, 0);


    }
  }

  public EditLine(ligneIdent: number): void {
    const selectedLigne: any = this.conditionModel.lstConditions.find((ligne: SubModel2) => {
      return ligne.ident === ligneIdent;
    });
    if (!this.edit || selectedLigne.editable) {
      this.edit = !this.edit;
      selectedLigne.editable = !selectedLigne.editable;
      if (this.listIdToDelete.indexOf(ligneIdent) !== -1) {
        this.listIdToDelete.splice(this.listIdToDelete.indexOf(ligneIdent), 1);
      }
      setTimeout(() => {
        if (this.keyValuePairAdded.findIndex((keyValuePair: { key: number, value: string }) => { return keyValuePair.key === ligneIdent }) > -1) {
          const value = (this.keyValuePairAdded.find((keyValuePair: { key: number, value: string }) => { return keyValuePair.key === ligneIdent }) as { key: number, value: string }).value;
          $(`#ligneContext option`)
            .filter(function (): any { return (($(this).attr('value') as string).toUpperCase() as any).indexOf(value.toUpperCase()) > -1 })
            .prop('selected', true);
          this.GetNameList(value);
        } else {
          $(`#ligneContext option`)
            .filter(function (): any { return (($(this).attr('value') as string).toUpperCase() as any).indexOf(selectedLigne.context.toUpperCase()) > -1 })
            .prop('selected', true).prop('selected', true);
          this.GetNameList(selectedLigne.context);
        }
        setTimeout(() => {
          $(`#ligneName option`)
            .filter(function (): any { return (($(this).attr('value') as string).toUpperCase() as any).indexOf(selectedLigne.name.toUpperCase()) > -1 })
            .prop('selected', true);
        }, 0);
      }, 0);

    }
  }

  public ChangeSelect(e: any, type: string, obj: SubModel2): void {
    switch (type) {
      case 'andOrOperator':
        obj.andOrOperator = e.value;
        break;
      case 'context':
        obj.context = ($(`#${e.id} option:selected`)[0].attributes as any)['name'].value;
        obj.name = '';
        break;
      case 'name':
        obj.name = e.value;
        break;
      case 'logicalOperator':
        obj.logicalOperator = e.value;
        break;
    }
  }

  public GetNameList(value: string): void {
    const objTableName: ConditionContext | undefined = this.contextModel.find((el: ConditionContext) => el.bo.toUpperCase() === value.toUpperCase());

    if (objTableName) {
      const list: ConditionColumnsModel | undefined = this.allnameModels.find(
        (el: ConditionColumnsModel) => {

          return el.tableName.toUpperCase() === objTableName.bo.toUpperCase()
        });

      if (list) {
        this.nameModel = list.lstColumns
      } else {
        this.nameModel = new Map<string, string>();
      }
    } else {
      this.nameModel = new Map<string, string>();
    }
    this.cd.detectChanges;
  }

  public getContextValue(id: string): string {
    const att = $(`#${id} option:selected`)[0];
    if (att)
      return ($(`#${id} option:selected`)[0].attributes as any)['value'].value;
    else
      return '';
  }

  public LoadFile(value: string): void {
    const document: ConditionDocumentsModel | undefined = this.listDocuments.find((doc: ConditionDocumentsModel) => doc.ident == value);
    if (document != undefined) {
      this.selectedCodeCondition = value;
      if (this.selectedCodeCondition !== '0') {
        this.modeleLoading = true;
        this.http.getHttp<ConditionModel>(`${this.core.AppParams.apiUrl}api/spefCompta/Conditions/GET_DOC_DETAILS/${document.name}/`)
          .subscribe((res: ConditionModel) => {
            this.modeleLoading = false;
            this.conditionModel = res.Conditions2;
            this.NameAlreadyExist(this.conditionModel.strName);
          });
      } else {
        this.conditionModel = new NewConditionModel();
        this.NameAlreadyExist(this.conditionModel.strName);
      }
      this.edit = false;
      this.newconditionModel = new SubModel2();
      this.UncheckAll();
    }
    else {
      this.toastservice.showInfoToast(`Le code ${value} n'existe pas`);
      this.LoadFile('0');
    }
  }

  public SaveConfig(): void {

    // verif s'il le nom du model est renseigné
    if (!this.conditionModel.strName) {
      this.toastservice.showWarningToast(`Le nom du fichier n'est pas renseigné`);
    } else if (!this.conditionModel.strDescription) {
      this.toastservice.showWarningToast(`La description du fichier n'est pas renseignée`);
    }
    else if (!this.nomExistant) {
      const model: ConditionModel = new ConditionModel();
      model.Mode = 'CREATE_XML_FILE';
      model.Conditions2 = this.conditionModel;
      this.saveLoading = true;
      this.http.postHttp<ConditionModel>(`${this.core.AppParams.apiUrl}api/spefCompta/Conditions/`, model)
        .subscribe((res: ConditionModel) => {
          if (res && res.Conditions2 && res.Conditions2.strName) {
            this.selectedCodeCondition = res.Conditions2.strName.replace('.xml', '');
            this.modeleLoading = true;
            this.http.getHttp<ConditionModel>(`${this.core.AppParams.apiUrl}api/spefCompta/Conditions/GET_DOCS_LIST/0`).subscribe(
              (result: ConditionModel) => {
                this.listDocuments = result.lstDocuments;
                this.modeleLoading = false;
              });
          }
          this.saveLoading = false;
        });
    }
  }


  public DeleteConfig(): void {
    if (this.conditionModel.strName && this.selectedCodeCondition) {
      this.deleteLoading = true;
      this.http.getHttp<ConditionModel>(`${this.core.AppParams.apiUrl}api/spefCompta/Conditions/DELETE/${this.conditionModel.strName}/`).subscribe(
        (result: ConditionModel) => {
          if (result.deleteSuccessfully) {
            this.conditionModel = new NewConditionModel();

            this.http.getHttp<ConditionModel>(`${this.core.AppParams.apiUrl}api/spefCompta/Conditions/GET_DOCS_LIST/0`).subscribe(
              (result: ConditionModel) => {
                this.listDocuments = result.lstDocuments;
                this.deleteLoading = false;
                this.closeDelete.nativeElement.click();
              });
          } else {
            this.deleteLoading = false;
          }
        });
    }
  }



  public DeleteSelect(e: any): void {
    if (e.checked) {
      this.listIdToDelete.push(Number(e.id));
    } else {
      this.listIdToDelete.splice(this.listIdToDelete.indexOf(Number(e.id)), 1);
    }
  }

  public AllSelect(e: any): void {
    if (this.conditionModel && this.conditionModel.lstConditions) {
      this.conditionModel.lstConditions.forEach((element: SubModel2) => {
        if (!element.editable) {
          const elements: any = document.getElementById(`${element.ident}`);
          if (elements !== undefined) {
            elements.checked = e.checked;
            if (e.checked) {
              this.listIdToDelete.push(element.ident);
            } else {
              this.listIdToDelete.splice(this.listIdToDelete.indexOf(element.ident), 1);
            }
          }
        }
      });
    }
  }

  public DeleteLigne(): void {
    this.listIdToDelete.forEach((idElement: number) => {
      const element: any = this.conditionModel.lstConditions.find((ligne: SubModel2) => ligne.ident.valueOf() === idElement);
      if (element !== undefined) {
        const indexElement: number = this.conditionModel.lstConditions.indexOf(element);
        if (!element.editable) {
          this.conditionModel.lstConditions.splice(indexElement, 1);
        }
      }
    });
    this.UncheckAll();
  }

  private UncheckAll(): void {
    const checkAll: any = document.getElementById(`selectAllCheck`);
    if (checkAll !== undefined) {
      checkAll.checked = false;
      this.listIdToDelete = new Array<number>();
    }
  }

  private SelectCheck(ligne: SubModel2): boolean {
    let result: boolean = false;
    result = !ligne.andOrOperator || !ligne.context || !ligne.name || !ligne.logicalOperator;
    return result;
  }
}
